import { modalTypes } from '../../types';

const defaultState = {
  updateChannel: {
    isOpen: false,
    data: null
  },
  createContact: {
    isOpen: false,
    data: null
  },
  deleteChannel: {
    isOpen: false,
    data: null
  },
  beastMode: {
    isOpen: false,
    data: null
  },
  photoViewer: {
    isOpen: false,
    data: null
  },
  linkThreads: {
    isOpen: false,
    data: null
  }
};

const map = {
  [modalTypes.UPDATE_MODAL]: (state, action) => ({
    ...state,
    ...action.payload
  })
};

export default (state = defaultState, action) =>
  (map[action.type] && map[action.type](state, action)) || state;
